import type { DocMigration } from "../docMigration";

function newUUID() {
  let d = new Date().getTime(),
    d2 = (typeof performance !== "undefined" && performance.now && performance.now() * 1000) || 0;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    let r = Math.random() * 16;
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : (r & 0x7) | 0x8).toString(16);
  });
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_232: DocMigration = {
  maxSchemaVersion: "0.0.232",
  description: "Studio option templates should use a uuid not a uid as an identifier",
  apply(json: any) {
    if (!json.optionTemplates) {
      json.optionTemplates = {};
    }
    if (!json.optionSetOverrides) {
      json.optionSetOverrides = {};
    }

    for (const [oldId, template] of Object.entries<any>(json.optionTemplates)) {
      if (!(oldId === template["id"])) {
        console.assert(false);
      }

      if (oldId.length < "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".length) {
        const uuid = newUUID();

        json.optionTemplates[uuid] = template;
        delete json.optionTemplates[oldId];
        template["id"] = uuid;

        for (const overrides of Object.values<any>(json.optionSetOverrides)) {
          if (overrides["parentId"] === oldId) {
            overrides["parentId"] = uuid;
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_232;
